import React from 'react'
import '../css/useragreement.css'

// 隐私保护协议布局
function PrivacyProtectionAgreement(props) {

    return (
        <div className="user-agreement-container">

            <header className="agreement-header">

                <h1>N2YUN隐私保护协议</h1>

                <div className="header-info">
                    <p>生效日期：2026年6月15日</p>
                </div>

                <div className="header-info">
                    <p>最后更新：2026年6月15日</p>
                </div>

            </header>

            <div className="agreement-content">

                <div className="agreement-text">

                    {/* 引言 */}
                    <section id="intro">

                        <h2>一、引言</h2>

                        <p>
                            欢迎使用N2YUN社区（以下简称“本社区”）。
                        </p>

                        <p>
                            为保障社区环境安全、防止未成年人参与限制性行为以及提升账号安全性，
                            本社区提供实名认证服务。
                        </p>

                        <p>
                            部分第三方业务服务器可能接入本社区实名认证服务，
                            用于验证当前账户是否符合相关操作条件。
                        </p>

                        <p>
                            第三方业务服务器仅可获取认证状态结果，
                            不会获取您的完整身份信息。
                        </p>

                        <p>
                            请您在使用本社区服务前仔细阅读本协议，
                            继续使用即视为您已阅读并同意本协议内容。
                        </p>

                    </section>

                    {/* 实名认证服务说明 */}
                    <section id="verify">

                        <h2>二、实名认证服务说明</h2>

                        <ul>

                            <li>
                                本社区提供实名认证服务，
                                用于验证账户真实性及年龄状态；
                            </li>

                            <li>
                                部分第三方业务服务器可能接入本社区实名认证状态接口；
                            </li>

                            <li>
                                实名认证结果可能用于：
                            </li>

                            <ul>
                                <li>年龄真实性验证</li>
                                <li>未成年人限制消费</li>
                                <li>高风险功能权限控制</li>
                                <li>账号安全保护</li>
                            </ul>

                            <li>
                                未成年人账户可能被限制部分功能或消费行为；
                            </li>

                        </ul>

                    </section>

                    {/* 信息收集 */}
                    <section id="collect">

                        <h2>三、信息收集范围</h2>

                        <ul>

                            <li>
                                为完成实名认证，
                                本社区可能收集以下信息：
                            </li>

                            <ul>
                                <li>真实姓名</li>
                                <li>身份证号码</li>
                                <li>实名认证状态</li>
                                <li>年龄验证状态</li>
                            </ul>

                            <li>
                                本社区仅收集完成认证所必要的信息；
                            </li>

                        </ul>

                    </section>

                    {/* 信息处理 */}
                    <section id="process">

                        <h2>四、信息处理方式</h2>

                        <ul>

                            <li>
                                用户身份信息由本社区进行安全处理；
                            </li>

                            <li>
                                第三方业务服务器仅可获取认证结果状态；
                            </li>

                            <li>
                                不会向第三方业务服务器提供完整身份证信息；
                            </li>

                            <li>
                                不会向第三方业务服务器提供真实姓名原文；
                            </li>

                            <li>
                                不会向第三方公开、出售或泄露用户个人信息；
                            </li>

                        </ul>

                    </section>

                    {/* 信息使用 */}
                    <section id="usage">

                        <h2>五、信息使用范围</h2>

                        <ul>

                            <li>身份真实性验证；</li>

                            <li>年龄状态验证；</li>

                            <li>未成年人限制消费；</li>

                            <li>高风险功能权限控制；</li>

                            <li>账号安全保护；</li>

                            <li>风险行为识别与安全风控；</li>

                        </ul>

                    </section>

                    {/* 数据安全 */}
                    <section id="security">

                        <h2>六、数据安全保护</h2>

                        <ul>

                            <li>
                                本社区采用加密方式进行数据传输与存储；
                            </li>

                            <li>
                                本社区采取合理安全措施保护用户信息；
                            </li>

                            <li>
                                包括但不限于：
                            </li>

                            <ul>
                                <li>HTTPS安全传输</li>
                                <li>权限访问控制</li>
                                <li>数据加密存储</li>
                                <li>日志审计机制</li>
                            </ul>

                            <li>
                                仅授权人员可在必要情况下访问相关数据；
                            </li>

                        </ul>

                    </section>

                    {/* 用户权利 */}
                    <section id="rights">

                        <h2>七、用户权利</h2>

                        <ul>

                            <li>
                                用户有权查询、更正或删除个人信息；
                            </li>

                            <li>
                                用户可申请撤回相关授权；
                            </li>

                            <li>
                                如法律法规另有规定，
                                本社区将按照相关规定执行；
                            </li>

                        </ul>

                    </section>

                    {/* 协议更新 */}
                    <section id="update">

                        <h2>八、协议更新</h2>

                        <ul>

                            <li>
                                本协议可能根据法律法规或业务需求进行调整；
                            </li>

                            <li>
                                更新后的协议将在相关页面进行展示；
                            </li>

                            <li>
                                您继续使用本社区服务，
                                即视为已接受更新后的协议内容；
                            </li>

                        </ul>

                    </section>

                    {/* 页脚 */}
                    <div className="agreement-footer">

                        <div className="important-note">

                            <h3>重要提示</h3>

                            <p>
                                <strong>
                                    完成实名认证或继续使用本社区服务，
                                    即代表您已阅读并同意《N2YUN隐私保护协议》。
                                </strong>
                            </p>

                        </div>

                        <div className="privacy-tip">

                            <p>
                                第三方业务服务器仅获取认证状态结果，
                                不会获取您的完整实名信息。
                            </p>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default PrivacyProtectionAgreement